import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

// Use the config if available, otherwise fallback to the hardcoded URL
const API_URL = config.API_URL + '/users';

class UserService {
  // Récupérer tous les utilisateurs
  getAllUsers() {
    console.log('UserService.getAllUsers - Calling API:', API_URL);
    // Add a timestamp to prevent caching
    const url = `${API_URL}?t=${new Date().getTime()}`;
    return axios.get(url, { 
      headers: authHeader()
    })
    .then(response => {
      console.log('UserService.getAllUsers - Success, users:', response.data?.length || 0);
      return response;
    })
    .catch(error => {
      console.error('UserService.getAllUsers - Error:', error.message);
      return Promise.reject(error);
    });
  }

  // Récupérer un utilisateur par son ID
  getUserById(id) {
    return axios.get(API_URL + '/' + id, { headers: authHeader() });
  }

  // Récupérer le profil complet de l'utilisateur
  async getUserProfile() {
    // Essayons avec l'endpoint /me qui est une convention courante pour le profil de l'utilisateur connecté
    const response = await axios.get(`${API_URL}/me`, { headers: authHeader() });
    return response.data;
  }

  // Récupérer le profil complet avec les statistiques d'armées
  async getUserProfileWithArmyStats() {
    const response = await axios.get(`${API_URL}/me/profile`, { headers: authHeader() });
    return response.data;
  }

  // Mettre à jour le profil de l'utilisateur
  async updateProfile(profileData) {
    // Modifier l'URL de mise à jour du profil pour correspondre à l'API
    const response = await axios.put(
      `${API_URL}/me`,
      profileData,
      { headers: authHeader() }
    );
    return response.data;
  }

  // Changer le mot de passe de l'utilisateur
  async changePassword(oldPassword, newPassword) {
    // Récupérer l'ID de l'utilisateur actuel depuis le localStorage
    const userStr = localStorage.getItem('user');
    if (!userStr) throw new Error('Utilisateur non connecté');
    
    const user = JSON.parse(userStr);
    const userId = user.id;
    
    if (!userId) throw new Error('ID utilisateur introuvable');
    
    // Créer l'objet de requête qui correspond à ce que le backend attend
    const updateRequest = {
      // Conserver le nom d'utilisateur et l'email actuels
      username: user.username,
      email: user.email,
      // Ajouter les champs pour le changement de mot de passe
      oldPassword: oldPassword,
      newPassword: newPassword
    };
    
    const response = await axios.put(
      `${API_URL}/${userId}`,
      updateRequest,
      { headers: authHeader() }
    );
    
    return response.data;
  }

  // Récupérer les statistiques de l'utilisateur
  getUserStats(id) {
    return axios.get(API_URL + '/' + id + '/stats', { headers: authHeader() });
  }

  // Récupérer les badges de l'utilisateur
  async getUserBadges() {
    const response = await axios.get(`${API_URL}/badges`, { headers: authHeader() });
    return response.data;
  }

  // Récupérer les activités de l'utilisateur
  async getUserActivities() {
    const response = await axios.get(`${API_URL}/activities`, { headers: authHeader() });
    return response.data;
  }

  // Récupérer l'utilisateur actuel
  getCurrentUser() {
    return axios.get(API_URL + '/me', { headers: authHeader() });
  }

  // Mettre à jour un utilisateur
  updateUser(id, userData) {
    return axios.put(API_URL + '/' + id, userData, { headers: authHeader() });
  }

  // Supprimer un utilisateur
  deleteUser(id) {
    return axios.delete(API_URL + '/' + id, { headers: authHeader() });
  }
}

export default new UserService(); 